import { jsxs, jsx } from 'react/jsx-runtime';
import { mergeStyleSets, Stack, Text, Pivot, PivotItem, CommandBarButton, ImageIcon, Link } from '@fluentui/react';
import { taxonomyItems, unifiedTaxonomyItems } from '../../../data/taxonomy.esm.js';
import { useState, useMemo } from 'react';
import { pivotStyles, commandBarStyles, linkStyles } from './styles.esm.js';
import { useTranslation } from 'react-i18next';
import { headerData, unifiedHeaderData } from '../../../data/data.esm.js';
import { capitalizeFirstLetter } from '../utils.esm.js';
import logger from '@agoras/logger';
import { homeContext } from '../context.esm.js';
import { appsourceRouteMatch } from '../../../router/appsource.esm.js';
import { imageMap } from '../../../data/images.esm.js';
import { useHydration } from '@agoras/hooks';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var classNames = mergeStyleSets({
    imageIcon: {
        margin: '0 4px'
    }
});
var appsourceTaxonomy = {
    categories: taxonomyItems.categories || [],
    industries: taxonomyItems.industries || [],
    products: headerData.Apps.filtersSection.map(function(param) {
        var title = param.title, subTitle = param.subTitle;
        return {
            title: title,
            icon: subTitle.subTitle.icon,
            navigateOptions: {
                type: subTitle.subTitle.url.filterType,
                query: subTitle.subTitle.url.query
            }
        };
    })
};
var unifiedTaxonomy = {
    categories: unifiedTaxonomyItems.categories || [],
    industries: unifiedTaxonomyItems.industries || [],
    products: unifiedHeaderData.Products.filtersSection.map(function(param) {
        var title = param.title, subTitle = param.subTitle;
        return {
            title: title,
            icon: subTitle.subTitle.icon,
            navigateOptions: {
                type: subTitle.subTitle.url.filterType,
                query: subTitle.subTitle.url.query
            }
        };
    })
};
var defaultTabKey = Object.keys(appsourceTaxonomy)[0];
var dataBiArea = 'homePage';
var PopularCategoriesAndIndustries = function(param) {
    var navigate = param.navigate, locale = param.locale, unifiedExperience = param.unifiedExperience;
    var t = useTranslation('home').t;
    var isHydrated = useHydration();
    var _useState = _sliced_to_array(useState(defaultTabKey), 2), selectedTab = _useState[0], setSelectedTab = _useState[1];
    var taxonomy = useMemo(function() {
        return unifiedExperience ? unifiedTaxonomy : appsourceTaxonomy;
    }, [
        unifiedExperience
    ]);
    var handleTabClick = function(item) {
        if (item) {
            var itemKey = item.props.itemKey;
            setSelectedTab(itemKey);
            logger.info(JSON.stringify({
                tab: itemKey
            }), _object_spread({
                action: 'Click',
                actionModifier: 'Tab',
                appName: 'home'
            }, homeContext));
        }
    };
    var handleLinkClick = function(param) {
        var navigateOptions = param.navigateOptions;
        var appsourceRoute = appsourceRouteMatch(_object_spread_props(_object_spread({}, navigateOptions), {
            params: {
                locale: locale
            }
        }));
        logger.info(JSON.stringify({
            href: "".concat(appsourceRoute.pathname).concat(appsourceRoute.search)
        }), _object_spread({
            action: 'Click',
            actionModifier: 'Internal Link'
        }, homeContext));
        navigate === null || navigate === void 0 ? void 0 : navigate(navigateOptions);
    };
    return /*#__PURE__*/ jsxs(Stack, {
        horizontalAlign: "center",
        styles: {
            root: {
                backgroundColor: '#091F2C',
                width: '100%',
                padding: '56px 16px'
            }
        },
        tokens: {
            childrenGap: 24
        },
        children: [
            /*#__PURE__*/ jsx(Text, {
                variant: "xxLarge",
                as: "h3",
                styles: {
                    root: {
                        color: 'white',
                        textAlign: 'center',
                        margin: 0
                    }
                },
                children: t('Popular categories and industries')
            }),
            /*#__PURE__*/ jsx(Pivot, {
                styles: pivotStyles,
                selectedKey: selectedTab,
                onLinkClick: handleTabClick,
                headersOnly: true,
                children: Object.keys(taxonomy).map(function(key) {
                    var displayName = capitalizeFirstLetter(key);
                    return /*#__PURE__*/ jsx(PivotItem, {
                        headerText: t(displayName),
                        itemKey: key,
                        headerButtonProps: {
                            'data-bi-id': displayName,
                            'data-bi-type': 'homeFilters',
                            'data-bi-area': dataBiArea,
                            disabled: !isHydrated
                        }
                    }, key);
                })
            }),
            /*#__PURE__*/ jsx(Stack, {
                horizontal: true,
                horizontalAlign: "center",
                wrap: true,
                tokens: {
                    childrenGap: 24
                },
                styles: {
                    root: {
                        maxWidth: '1296px'
                    }
                },
                children: taxonomy[selectedTab].slice(0, 12).map(function(param) {
                    var title = param.title, icon = param.icon, navigateOptions = param.navigateOptions;
                    var _navigateOptions_query;
                    var _imageMap_;
                    var svgIcon = (_imageMap_ = imageMap["".concat(icon, "Grey")]) !== null && _imageMap_ !== void 0 ? _imageMap_ : imageMap[icon];
                    var tabType = navigateOptions.query ? Object.keys(navigateOptions.query)[0] : '';
                    var itemId = ((_navigateOptions_query = navigateOptions.query) === null || _navigateOptions_query === void 0 ? void 0 : _navigateOptions_query[tabType]) || '';
                    return /*#__PURE__*/ jsx(CommandBarButton, {
                        iconProps: {
                            iconName: icon
                        },
                        onRenderIcon: svgIcon && isHydrated ? function() {
                            return /*#__PURE__*/ jsx(ImageIcon, {
                                imageProps: {
                                    src: svgIcon,
                                    width: 16,
                                    height: 16
                                },
                                className: classNames.imageIcon
                            });
                        } : undefined,
                        text: t(title, {
                            ns: 'taxonomy'
                        }),
                        styles: commandBarStyles,
                        onClick: function() {
                            return handleLinkClick({
                                navigateOptions: navigateOptions
                            });
                        },
                        "data-bi-id": itemId,
                        "data-bi-name": title,
                        "data-bi-type": tabType,
                        "data-bi-area": dataBiArea
                    });
                })
            }),
            /*#__PURE__*/ jsx(Link, {
                styles: linkStyles,
                onClick: function() {
                    return handleLinkClick({
                        navigateOptions: {
                            type: 'App'
                        }
                    });
                },
                children: t("See all ".concat(selectedTab))
            })
        ]
    });
};

export { appsourceTaxonomy, PopularCategoriesAndIndustries as default };
